export const SURVEY_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
  INTERNAL: 2,
};

export const SURVEY_QUESTION_TYPE = {
  TEXT: 1,
  MULTILINE: 2,
  LINEAR_SCALE: 3,
}

export const surveyQuestionTypes = [
  { id: SURVEY_QUESTION_TYPE.TEXT, name: 'Texto simples' },
  { id: SURVEY_QUESTION_TYPE.MULTILINE, name: 'Texto multilinhas' },
  { id: SURVEY_QUESTION_TYPE.LINEAR_SCALE, name: 'Escala' }
]